import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../assets/css/sidebar.css";
import userlogo from "../../assets/images/user.jpg";
import logo from "../../assets/images/logoname.png";
import logosmall from "../../assets/images/logosmall.png";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/features/authSlice";
import { persistor } from "../../redux/store";
import {
  ShieldCheckIcon,
  Bars3BottomRightIcon,
  Bars3BottomLeftIcon,
  ChartBarSquareIcon,
  Squares2X2Icon,
  IdentificationIcon,
  UserIcon,
  ClockIcon,
  Cog6ToothIcon,
  MegaphoneIcon,
  ExclamationTriangleIcon,
  BuildingOffice2Icon,
  DocumentTextIcon,
  ArchiveBoxIcon,
  HeartIcon,
  GlobeAltIcon,
  StarIcon,
  CpuChipIcon,
  UserGroupIcon,
  ChatBubbleLeftRightIcon
} from "@heroicons/react/24/outline";


const Sidebar = ({ callpage, call, widthExpand, is_not_expand }: any) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [userName] = useState("User");  // Default userName
  const [visibleDropDownMenu, setVisibleDropDownMenu] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  const handleLogout = () => {
    dispatch(logout());
    persistor.purge(); // Clears persisted auth state
    navigate("/admin/login");
  };

  const handleDropdownMenu = () => setVisibleDropDownMenu(!visibleDropDownMenu);
  const toggleSidebar = () => call();

  const iconClass = "w-6 h-6";

  const isMenuActive = (to: string) => {
    if (to === "/admin/" || to === "/admin") {
      return location.pathname === "/admin" || location.pathname === "/admin/";
    }
    return location.pathname === to || location.pathname.startsWith(to);
  };

  const menuItems = [
    { to: "/admin/", icon: <Squares2X2Icon className={iconClass} />, label: "Dashboard" },
    { to: "/admin/website-analytics", icon: <GlobeAltIcon className={iconClass} />, label: "Website Analytics" },
    { to: "/admin/play-reviews", icon: <StarIcon className={iconClass} />, label: "Play Store Reviews" },
    { to: "/admin/play-vitals", icon: <CpuChipIcon className={iconClass} />, label: "Play Store Vitals" },
    // { to: "/admin/advertisement", icon: <MegaphoneIcon className={iconClass} />, label: "Advertisement" },
    { to: "/admin/profiles", icon: <UserIcon className={iconClass} />, label: "Verified Profiles" },
    { to: "/admin/nonverifiedprofiles", icon: <UserGroupIcon className={iconClass} />, label: "Non Verified Profiles" },
    { to: "/admin/stories", icon: <ClockIcon className={iconClass} />, label: "Stories" },
    { to: "/admin/matrimonial", icon: <IdentificationIcon className={iconClass} />, label: "Matrimonial" },
    { to: "/admin/business", icon: <BuildingOffice2Icon className={iconClass} />, label: "Business" },
    { to: "/admin/products", icon: <ArchiveBoxIcon className={iconClass} />, label: "Products" },
    // { to: "/admin/livevideos", icon: <VideoCameraIcon className={iconClass} />, label: "Live Videos" },
    { to: "/admin/jobdesc", icon: <DocumentTextIcon className={iconClass} />, label: "Job Descriptions" },
    { to: "/admin/leads", icon: <ChartBarSquareIcon className={iconClass} />, label: "New Leads" },
    // { to: "/admin/livesupport", icon: <ChatBubbleLeftRightIcon className={iconClass} />, label: "Live Support" },
    { to: "/admin/subadmins", icon: <ShieldCheckIcon className={iconClass} />, label: "Sub Admins" },
    { to: "/admin/advertisement", icon: <MegaphoneIcon className={iconClass} />, label: "Advertisements" },
    { to: "/admin/activeusers", icon: <IdentificationIcon className={iconClass} />, label: "Active Users" },
    { to: "/admin/chats", icon: <ChatBubbleLeftRightIcon className={iconClass} />, label: "Chats" },
    { to: "/admin/bloodgroup", icon: <HeartIcon className={iconClass} />, label: "Blood Group" },
    { to: "/admin/scheduled-notifications", icon: <MegaphoneIcon className={iconClass} />, label: "Notification Center" },
    { to: "/admin/system-errors", icon: <ExclamationTriangleIcon className={iconClass} />, label: "System Errors" },
    { to: "/admin/settings", icon: <Cog6ToothIcon className={iconClass} />, label: "Settings" },
  ];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <header className={`container-top ${is_not_expand ? "width-navbar" : "width-expand-navbar"}`}>
        <div className="flex align-items-center">
          <span>
            {is_not_expand || isMobile ? <img src={logosmall} alt="ss" className="logosizesmall" /> : <img src={logo} alt="sagar samaj" className="logosize" />}
          </span>
          {location.pathname !== "/livesupport" && (<div className={`absolute ${is_not_expand || isMobile ? "width-menu" : "width-expand-menu"}`}>
            {is_not_expand || isMobile ? (
              <Bars3BottomRightIcon className="cursor-pointer w-10 h-10" onClick={toggleSidebar} />
            ) : (
              <Bars3BottomLeftIcon className="cursor-pointer w-10 h-10" onClick={toggleSidebar} />
            )}
          </div>)}
        </div>
        <div className="flex items-center gap-3">
          {/* <div style={{ position: "relative", display: "inline-block", marginTop: "10px" }}>
            <BellIcon style={{ fontSize: "2rem", cursor: "pointer" }} className="w-8 h-8" />
            <Badge
              value="2"
              severity="danger"
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                transform: "translate(50%, -50%)",
                zIndex: 1,
              }}
            />
          </div> */}

          {/* User Profile */}
          <div className="flex align-items-center">
            <div className="ml-1 user-profile-logo">
              <img src={userlogo} alt="userlogo" className="user-logo" onClick={handleDropdownMenu} />
            </div>
          </div>
        </div>

        {/* Dropdown Menu */}
        {visibleDropDownMenu && (
          <div className="dropdown">
            <div className={`grid w-full ${widthExpand ? "hidden" : ""}`}>
              <div className="col-12 ml-2 profile-setting-text text-center">{userName}</div>
            </div>
            {/* <div className={`grid ${widthExpand ? "hidden" : ""}`}>
              <hr className="line" />
            </div>
            <div className="grid">
              <div className="col-12 ml-2 profile-setting-text cursor-pointer">My Profile</div>
            </div>
            <div className="grid">
              <hr className="line" />
            </div>
            <div className="grid">
              <div className="col-12 ml-2 profile-setting-text cursor-pointer">Profile Setting</div>
            </div>
            <div className="grid">
              <hr className="line" />
            </div> */}
            <div className="grid">
              <div className="col-12 ml-2 profile-setting-text cursor-pointer" onClick={handleLogout}>
                Logout
              </div>
            </div>
          </div>
        )}
      </header >

      {/* Sidebar */}
      {
        location.pathname !== "/admin/livesupport" && (<aside>
          <div className={`sidebar ${is_not_expand ? "width-sidebar" : "width-expand-sidebar"}`}>
            <div className="menu mt-1">
              {menuItems.map(({ to, icon, label }) => (
                <Link
                  to={to}
                  key={to}
                  className={`menu-item ${isMenuActive(to) ? "selected" : ""} ${is_not_expand ? "menu-not-expand" : ""}`}
                  onClick={callpage}
                >
                  {icon}
                  <span className={`menu-text ${is_not_expand ? "hidden" : "block"}`}>{label}</span>
                </Link>
              ))}
            </div>
          </div>
        </aside>)
      }
    </>
  );
};

export default Sidebar;
